import type { PdsModification } from '../types';
import type { PdsApiHistoryEntry } from './types';

const toCents = (amount?: number) => Math.round((amount ?? 0) * 100);

// Du plus récent au plus ancien : la dernière modification est celle qu'on veut lire en premier.
// Seules comptent les entrées qui ont touché aux lignes ; le reste de l'historique (création, paiement, statut) n'est pas
// une modification de la commande.
export const toModifications = (
  entries: PdsApiHistoryEntry[],
): PdsModification[] =>
  entries
    .filter(
      (entry) =>
        entry.type === 'lines_adjusted' && Array.isArray(entry.payload?.lines),
    )
    .map((entry) => {
      const lines = (entry.payload?.lines ?? []).map((line) => ({
        name: line.designation || 'Produit',
        from: line.qtyBefore ?? 0,
        to: line.qtyAfter ?? 0,
        refundCents: toCents(line.amount),
      }));
      return {
        id: entry.id,
        at: Date.parse(entry.createdAt),
        reason: entry.payload?.reason?.trim() || undefined,
        refundCents:
          entry.payload?.amount === undefined
            ? lines.reduce((sum, line) => sum + line.refundCents, 0)
            : toCents(entry.payload.amount),
        lines,
      };
    })
    .sort((a, b) => b.at - a.at);
